<template>
  <div class="typography-shades-and-opacity-content" id="identidade-visual-tipografia-tons-e-opacidade" data-search-anchor>
    <div class="title-typography-shades-and-opacity-wrapper">
      <h1 class="typography-shades-and-opacity-span">{{ typographyShadesAndOpacityTitleSpan }}</h1>
      <h1 class="typography-shades-and-opacity-title">{{ typographyShadesAndOpacityTitle }}</h1>
    </div>
    <div class="description-typography-shades-and-opacity-wrapper">
      <div class="typography-shades-and-opacity-icon">
        <IconCheck />
        <p class="typography-shades-and-opacity-description">
          {{ typographyShadesAndOpacityDescription1 }}
        </p>        
      </div>
      <div class="typography-shades-and-opacity-fica-a-dica">
        <p class="fica-a-dica">
          {{ typographyShadesAndOpacityDescription2 }}
        </p>
        <p class="typography-shades-and-opacity-description3">
          {{ typographyShadesAndOpacityDescription3 }}
        </p>
      </div>
    </div>
    <div
      class="typography-shades-and-opacity-card-item"
      :style="{ backgroundImage: `url(${typographyShadesAndOpacityImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import TypographyPageMixin from '@/mixins/typography-page-mixin'
import { TypographyPageStore } from '@/store/visual-identity-page/typography-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class TypographyShadesAndOpacitySection extends Mixins(TypographyPageMixin) {
  typographyPageStore: PageStoreContract = getModule(TypographyPageStore, this.$store)

  get typographyShadesAndOpacityTitleSpan(): string {
    return this.getElementTitle(8, 0)
  }

  get typographyShadesAndOpacityTitle(): string {
    return this.getElementText(8, 0)
  }

  get typographyShadesAndOpacityDescription1(): string {
    return this.getElementText(8, 1)
  }

  get typographyShadesAndOpacityDescription2(): string {
    return this.getElementText(8, 2)
  }

  get typographyShadesAndOpacityDescription3(): string {
    return this.getElementText(8, 3)
  }

  get typographyShadesAndOpacityImageSrc(): string {
    return this.getElementMedia(8, 3)
  }

  async getTypographyPage(): Promise<void> {
    await this.typographyPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.typographyPageStore.isLoading) {
      await this.getTypographyPage()
    }
  }
}
</script>

<style lang="scss">
.typography-shades-and-opacity-content {
  display: grid;
  max-width: 1032px;
  width: 100%;
}

.title-typography-shades-and-opacity-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.typography-shades-and-opacity-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.typography-shades-and-opacity-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.typography-shades-and-opacity-icon {
  display: flex;
  align-items: center;
}

.description-typography-shades-and-opacity-wrapper {  
  position: relative;
  align-items: flex-start;
  
  display: grid;
  grid-template-columns: 51.2% 48.8%;  
}

.typography-shades-and-opacity-fica-a-dica{
  margin-top: 1rem;
}

.typography-shades-and-opacity-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 7px;
  
  width: 378px;
}

.fica-a-dica,
.typography-shades-and-opacity-description3 {
  font-size: 16px;  
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  margin-top: 0;
  margin-top: 0;
  width: 430px;
}

.typography-shades-and-opacity-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 710px;

  border-radius: 8px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
